export const useDialogValuesStatusHelper = (record) => {

    return {
        isComplete: record?.dialogValue?.isComplete && !record?.dialogValue?.signingNeeded,
        isAwaitingSigning: record?.dialogValue?.isComplete && record?.dialogValue?.signingNeeded && !record?.dialogValue?.isSigned,
        isCompleteSigned: record?.dialogValue?.isComplete && record?.dialogValue?.signingNeeded && record?.dialogValue?.isSigned,
    }
}